import React, { useEffect } from "react";
import $ from "jquery";
import { connect } from "react-redux";
import { Button} from "@material-ui/core";
import { updateChoicesListInit } from "../actions";
import TemplateLabel from "./TemplateLabel";
import TemplateHint from "./TemplateHint";
import {
  convertArray,
  deleteItem,
  editItem,
  convertData
} from "../function/select_function";
import { TemplateRatingBox } from "./TemplateSelect/TemplateRatingBox";
import { DefaultSelect } from "./TemplateSelect/TemplateSelectDefault";
import { DialogAddChoice } from "./TemplateSelect/DialogAddChoice";
import { TemplateBoxtag } from "./TemplateSelect/TemplateBoxtag";
import { TemplateStarRating } from "./TemplateSelect/TemplateStarRating";
import Swal from "sweetalert2";


const TemplateSelect = (props) => {
  const [open, setOpen] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [choiceEdit, setChoiceEdit] = React.useState({});

  const handleClickOpen = (choice = "") => {
    setOpen(true);
    if (choice) {
      setChoiceEdit(choice);
      setOpenEdit(true);
    } else {
      setChoiceEdit({});
      setOpenEdit(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddNewChoice = (choicesList) => {
    setOpen(false);
    const arr = $("#" + props.choice + "form-content")
      .serializeArray()
      .map(function (v) {
        return [v.name, v.value];
      });
    const header = props.choicesList[0];
    const result = convertArray(arr, header);
    const choicesListUpdate = [...props.choicesList, result];
    let choiceName = props.choice;
    if (!choiceName) {
      choiceName = arr[0][1];
    }
    props.dispatch(
      updateChoicesListInit(props.questionId, choicesListUpdate, choiceName)
    );
  };
  const handleEditChoice = (choicesList) => {
    setOpen(false);
    const arrForm = $("#" + props.choice + "form-content")
      .serializeArray()
      .map(function (v) {
        return [v.name, v.value];
      });

    const header = props.choicesList[0];
    const result = convertArray(arrForm, header);
    let arr = props.choicesList;
    editItem(arr, choiceEdit, result);
    let choiceName = props.choice;
    if (!choiceName) {
      choiceName = arr[0][1];
    }
    props.dispatch(updateChoicesListInit(props.questionId, arr, choiceName));
  };
  const handleDeleteChoice = (choice, choicesList) => {
    Swal.fire({
      icon:'question',
      title: 'Are you sure delete this choice?',
      showCancelButton: true,
      confirmButtonText: 'Yes! Delete it.',      
      confirmButtonColor:"var(--red-color)",
      cancelButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        let arr = choicesList;
        deleteItem(arr, choice);
        props.dispatch(updateChoicesListInit(props.questionId, arr, props.choice));
      }
    })
    
  };
  useEffect(() => {
    if (
      !props.choicesList ||
      (props.choicesList && props.choicesList.length === 3)
    ) {
      props.dispatch(
        updateChoicesListInit(
          props.questionId,
          window.Choices.values,
          props.choice
        )
      );
    } else {
      props.dispatch(
        updateChoicesListInit(props.questionId, props.choicesList, props.choice)
      );
    }
  }, []);

  let choicesListNew = [];
  if (props.choicesList && props.choicesList.length > 1) {
    choicesListNew = convertData(props.choicesList);
  }
  let choiceListRender = openEdit
    ? Object.entries(choiceEdit)
    : props.choicesList[0];
  return (
    <div style={{ width: "100%" }}>
      {
          props.appearance.indexOf("text-nolabel") === -1 &&
          <TemplateLabel label={props["label::"+props.language]}  required={props.required}/>
      }
      <TemplateHint hint={props["hint::" + props.language]} />
      {renderTemplate({
        ...props,
        choicesListNew,
        handleClickOpen,
        handleDeleteChoice,
      })}
      {((props.collector.Choice === "TRUE") &&
        window.ListNameDefault.indexOf(props.choice) === -1 && !props.previewForm) && (
          <>
            <Button
              color="primary"
              onClick={(e) => {
                handleClickOpen();
                e.preventDefault()
                e.stopPropagation()
              }}
              fullWidth
            >
              Add choice
            </Button>
            <DialogAddChoice 
              key={"key-DialogAddChoice"}
              {...props} 
              open={open} 
              handleClose={handleClose} 
              openEdit = {openEdit} 
              choiceListRender = {choiceListRender} 
              handleEditChoice = {handleEditChoice} 
              handleAddNewChoice = {handleAddNewChoice} 
              choicesListNew = {choicesListNew}
            />
          </>
        )}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    choicesList: state["choices_list"],
    choicesListLength: state["choices_list"].length,
    previewForm: state["previewForm"],
    choice: state['questionsList'][props.questionId].choice,
    appearance: state['questionsList'][props.questionId].appearance,
    collector: state['questionsList'][props.questionId].collector,
    display : state['questionsList'][props.questionId].display,
    ["label::"+props.language] : state['questionsList'][props.questionId]["label::"+props.language],
    ["hint::"+props.language] : state['questionsList'][props.questionId]["hint::"+props.language]
  };
};

export default connect(mapStateToProps)(TemplateSelect);





const renderTemplate = ({ ...props }) => {
  if (props.display[0]?.indexOf("rating_box") > -1) {
    return (
      <TemplateRatingBox
        key={props.questionId + props.choice}
        choicesListNew={props.choicesListNew}
        {...props}
        handleClickOpen={props.handleClickOpen}
        handleDeleteChoice={props.handleDeleteChoice}
      />
    );
  } else if (props.display[0]?.indexOf("boxtag") > -1 || props.display[0]?.indexOf("tagging") > -1) {
    return (
      <TemplateBoxtag
        key={props.questionId + props.choice}
        choicesListNew={props.choicesListNew}
        {...props}
        handleClickOpen={props.handleClickOpen}
        handleDeleteChoice={props.handleDeleteChoice}
      />
    );
  } else if (props.display[0]?.indexOf("star_rating") > -1) {
    return (
      <TemplateStarRating
        key={props.questionId + props.choice}
        choicesListNew={props.choicesListNew}
        {...props}
        handleClickOpen={props.handleClickOpen}
        handleDeleteChoice={props.handleDeleteChoice}
      />
    );
  }
  
  return (
    <DefaultSelect
      key={props.questionId + props.choice}
      choicesListNew={props.choicesListNew}
      {...props}
      handleClickOpen={props.handleClickOpen}
      handleDeleteChoice={props.handleDeleteChoice}
      
    />
  );
};





